import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
const styles = theme => ({
    root: {
      flexGrow: 1,
      maxWidth: 1170,
      margin: 'auto',
    }
  });
class SectionLoans extends Component {
    render() {
        const { classes } = this.props;
        return (
            <section className="loans">
                <div className={classes.root}>
                    <Grid item xs={12} container>
                        <Grid item sm={7} xs={12} className="header_left">
                            <div className="federal_loans">
                                <h3>Federal Student Loans</h3>
                                <p>The standard repayment plan expects borrowers to pay off their debt in less than 10 years. For many, however, it can take twice as long</p>
                            </div>
                        </Grid>
                        <Grid item sm={5} xs={12} className="header_right">
                            <div className="loan_value">
                                <p className="loan_amount">$37k</p>
                                <p className="loan_average_label">average student loan debt</p>
                            </div>
                        </Grid>
                        
                    </Grid>
                </div>
            </section>
        )
    }
}
SectionLoans.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(SectionLoans);


// WEBPACK FOOTER //
// ./src/components/Landing/SectionLoans.js